export const translationEN = {
  top: {
    text_1: 'Fresh food & better planet!',
    text_2: 'THOUSANDS',
    text_3: 'OF RECIPES',
    text_4: 'A place where help you to manage ingredients',
    text_5: 'Recipes from many cuisines',
    text_6: 'Weekly menus, shopping list',
  },
  main_function: {
    text_1: 'Main functions',
    text_1_1: 'Keep your food fresh',
    text_1_2: 'Get alerts from our freshness checker to help avoid throwing food away',
    text_2_1: 'AI recipe suggestions',
    text_2_2: 'Discover recipes from many cuisines in the world based on the ingredients left in your fridge',
    text_3_1: 'Menus for the whole week',
    text_3_2: 'Create menus for the whole week',
    text_4_1: 'Shopping list',
    text_4_2: 'Create and update shopping lists to get ready for shopping trips',
    text_5: 'Download',
    text_6: 'iFridge will help you',
    text_7_1: 'Become a better housewife',
    text_7_2: 'Reduce waste & make a healthier planet',
    text_7_3: 'Enjoy cooking',
  },
  rate_box: {
    text_1: 'User Reviews',
  },
  faqs: {
    text_1: 'FAQs',
    text_2_1: 'What types of accounts are there? Can I use the app for free?',
    text_2_2: `You have the first month to use all the functions of the application for free and without ads.
      <br /><br />After the first month, your account will automatically become a FREE ACCOUNT.
      <br /><br />With a FREE ACCOUNT, you can use the basic functions of the application such as: material ingredients, daily ingredients status report. You cannot use some advanced functions such as: AI recipe suggestions, weekly menus, shopping list. Ads will also appear when you use the application.
      <br /><br />To use all the functions of the application without ads. You need to upgrade to a PREMIUM ACCOUNT, with a very reasonable monthly cost
    `,
    text_3_1: 'How much does a PREMIUM ACCOUNT cost?',
    text_3_2: `You can subscribe monthly or annually.
      <br /><br />Monthly cost: $0.99/month.
      <br /><br />Annual cost: $9.99/year.
      <br /><br />There are no other fees.`,
    text_4_1: 'Can I subscribe for a PREMIUM ACCOUNT without paying?',
    text_4_2: `You absolutely can.
      <br /><br />To subscribe a Premium ACCOUNT, you use iFridge Points.
      <br /><br />iFridge Points can be purchased through the App Store/Google Play: On the Settings screen, tap the Points menu which will take you to the Points purchase screen.
      <br /><br />Or you can earn iFridge Points by watching ads: On the Settings screen, tap the Other settings menu, tap Watch ads.`,
    text_5_1: 'Do I get iFridge Points for watching ads?',
    text_5_2: `You can earn iFridge Points by watching ads.'
      <br /><br />Depending on your country, you will receive a certain number of iFridge Points for each ad view (according to Google Admob regulations). After viewing an ad, you need to wait 20 minutes to be able to view the next ad.`,
    text_6_1: 'Can I earn iFridge Points through referring friends?',
    text_6_2: `You can absolutely get iFridge Points through referrals to friends.
      <br /><br />Depending on your country, you can get a certain amount of iFridge Points when you refer friends by sharing information about iFridge on social networks such as Facebook, Twitter, etc.
      <br /><br />In 1 month, you can only receive iFridge Points once for referrals.`,
    text_7_1: 'Is my personal data stored securely? Is it shared with third parties?',
    text_7_2:
      'Your data is stored entirely on your phone and is fully secure. We do not store your personal data on our servers, nor do we share your personal data with any third parties.',
    text_8_1: 'If I need support, how do I contact?',
    text_8_2: `You can contact us via the Contact us function: On the Settings screen, select Other settings, select Contact us.
      <br /><br />Or send support requests/feedback directly to email: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'Love may come and go,',
    text_2: 'but hunger visits every day',
  },
};
